import React, { useEffect } from 'react';
import { Instagram, ExternalLink } from 'lucide-react';

// ─────────────────────────────────────────────────────────────
// 🎯 EMBEDS OFICIALES DE INSTAGRAM
// Añade aquí las URLs de tus posts / reels de Instagram.
// Formato: 'https://www.instagram.com/p/CODIGO/'  o  '/reel/CODIGO/'
// Puedes obtenerlas desde tu app: post → "..." → "Copiar enlace"
// ─────────────────────────────────────────────────────────────
const INSTAGRAM_POST_URLS = [
  'https://www.instagram.com/p/DbXh4q9F0Cj/',
  'https://www.instagram.com/p/DbAeaToO-6H/',
  'https://www.instagram.com/reel/DZ-dhBUu1RL/',
  'https://www.instagram.com/p/DZCMTIAl9sV/',
  'https://www.instagram.com/p/DYaZNV6l5vi/',
  'https://www.instagram.com/reel/DXmdrF_Dhak/',
];

const IG_USERNAME = 'jrf_sportswear_';
const IG_PROFILE_URL = `https://www.instagram.com/${IG_USERNAME}`;

const InstagramFeed = () => {
  useEffect(() => {
    // Cargar el script oficial de Instagram embed cuando haya posts
    if (INSTAGRAM_POST_URLS.length === 0) return;

    const scriptId = 'instagram-embed-script';
    if (document.getElementById(scriptId)) {
      // Si ya está cargado, refrescar embeds
      if (window.instgrm) {
        window.instgrm.Embeds.process();
      }
      return;
    }
    const script = document.createElement('script');
    script.id = scriptId;
    script.async = true;
    script.src = '//www.instagram.com/embed.js';
    document.body.appendChild(script);
  }, []);

  return (
    <section className="py-12 bg-gradient-to-b from-gray-50 to-white overflow-x-hidden">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-3 mb-3">
            <div className="w-10 h-10 bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 rounded-xl flex items-center justify-center shadow-md">
              <Instagram className="w-6 h-6 text-white" />
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-800">
              @{IG_USERNAME}
            </h2>
          </div>
          <p className="text-gray-600 text-sm md:text-base">
            Síguenos y comparte tu estilo con <span className="font-semibold text-black">#JRFSportswear</span>
          </p>
        </div>

        {/* Posts */}
        {INSTAGRAM_POST_URLS.length > 0 ? (
          <div className="relative grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto overflow-hidden [&_iframe]:!min-w-0 [&_iframe]:!max-w-full">
            {INSTAGRAM_POST_URLS.map((url, idx) => (
              <blockquote
                key={url + idx}
                className="instagram-media"
                data-instgrm-permalink={url}
                data-instgrm-version="14"
                style={{
                  background: '#FFF',
                  border: 0,
                  borderRadius: '12px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                  margin: '0 auto',
                  maxWidth: '540px',
                  minWidth: 0,
                  padding: 0,
                  width: '100%'
                }}
              >
                <a href={url} target="_blank" rel="noopener noreferrer">Ver en Instagram</a>
              </blockquote>
            ))}
          </div>
        ) : (
          // Fallback bonito cuando aún no hay posts configurados
          <div className="max-w-3xl mx-auto">
            <a
              href={IG_PROFILE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="block relative overflow-hidden rounded-2xl shadow-lg group"
            >
              <div className="bg-gradient-to-br from-purple-600 via-pink-500 to-orange-400 p-10 md:p-16 text-center text-white">
                <Instagram className="w-16 h-16 mx-auto mb-4 opacity-90" />
                <h3 className="text-2xl md:text-3xl font-bold mb-2">Descubre nuestro Instagram</h3>
                <p className="text-white/90 text-sm md:text-base mb-6 max-w-md mx-auto">
                  Fotos de nuestras clientas, nuevas colecciones, tips de entrenamiento y mucho más
                </p>
                <div className="inline-flex items-center gap-2 px-8 py-3 bg-white text-black font-bold rounded-full group-hover:scale-105 transition-transform">
                  <Instagram className="w-5 h-5" />
                  Seguir a @{IG_USERNAME}
                  <ExternalLink className="w-4 h-4" />
                </div>
              </div>
            </a>
          </div>
        )}

        {/* CTA final (solo si hay posts) */}
        {INSTAGRAM_POST_URLS.length > 0 && (
          <div className="text-center mt-10">
            <a
              href={IG_PROFILE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-8 py-3 bg-gradient-to-r from-purple-600 via-pink-500 to-orange-400 text-white font-semibold rounded-full hover:opacity-90 transition shadow-md"
              data-testid="follow-instagram-btn"
            >
              <Instagram className="w-5 h-5" />
              Ver más en Instagram
              <ExternalLink className="w-4 h-4" />
            </a>
          </div>
        )}
      </div>
    </section>
  );
};

export default InstagramFeed;
